import { VideosInfiniteHorizontalScroller } from "components/videos/VideosInfiniteHorizontalScroller"
import { UseMoreParams } from "models/convention-api/types"
import ConventionVideo from "models/convention-api/v1/ConventionVideo"
import React, { useMemo } from "react"

const USE_MORE_PARAMS: UseMoreParams = {
  limit: 20,
  sort: "-created_at",
  includes: ["institution", "video_count"],
}

interface RecentlyAddedVideosProps {
  fallbackData: ConventionVideo[]
}

export const RecentlyAddedVideos = (props: RecentlyAddedVideosProps) => {
  const { fallbackData } = props
  const pageParams = useMemo(
    () => ({
      ...USE_MORE_PARAMS,
      fallbackData,
    }),
    [fallbackData],
  )
  // hide the scroller if there are no videos for recently added
  if (fallbackData.length === 0) return null
  return (
    <VideosInfiniteHorizontalScroller
      pagesParams={pageParams}
      title="Recently Added"
      emptyStateMessage="No videos found"
    />
  )
}
